import axios from 'axios';
import { IS_LOADING, WITHDRAWAL_LIST_SUCCESS, WITHDRAWAL_LIST_ERROR, TRANSACTION_LIST_SUCCESS, TRANSACTION_LIST_ERROR, TRANSACTION_DOWNLOAD_SUCCESS, TRANSACTION_DOWNLOAD_ERROR, TRANSACTION_GET_DOWNLOAD_FILES_SUCCESS, TRANSACTION_GET_DOWNLOAD_FILES_ERROR, TRANSACTION_FILTER_SUCCESS, TRANSACTION_FILTER_ERROR, WALLET_LIST_SUCCESS, WALLET_LIST_ERROR, WALLET_FILTER_SUCCESS, WALLET_FILTER_ERROR, WALLET_UPDATE_SUCCESS, WALLET_UPDATE_ERROR, TDS_LIST_SUCCESS, TDS_LIST_ERROR, WALLET_TRANS_ERROR, WALLET_TRANS_SUCCESS } from './Type';
import { baseUrlPostGres } from '../constant';
import { apiHeader } from './ApiHeader';
import { saveAs } from 'file-saver'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HandleError from '../HandleError';
import { apiVersion } from 'src/utils/apiVersion';

let debounceTimerTransactionList;
export const GetTransactionListAction = (page, size) => (dispatch) => {
    return new Promise((resolve) => {
        const timeout = debounceTimerTransactionList ? 1000 : 0;
        if (debounceTimerTransactionList) clearTimeout(debounceTimerTransactionList);
        debounceTimerTransactionList = setTimeout(async () => {
            dispatch({ type: IS_LOADING });

            try {
                const response = await axios.get(
                    `${baseUrlPostGres()}/admin/${apiVersion.v1}/transaction/list?page=${page}&size=${size}`,
                    { headers: apiHeader() }
                );

                dispatch({
                    type: TRANSACTION_LIST_SUCCESS,
                    payload: response
                });
            } catch (errors) {
                HandleError(errors.response?.data);
                dispatch({
                    type: TRANSACTION_LIST_ERROR,
                    payload: errors
                });
            }
            resolve(true)
        }, timeout);
    });
};


export const ResetTransactionListAction = () => async (dispatch) => {
    dispatch({
        type: TRANSACTION_LIST_SUCCESS,
        payload: {}
    })
}

export const GetTransactionDownload = (body) => async (dispatch) => {
    console.log("bodybodybody", body);
    // return  false;
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/transaction/download`, body, {
            headers: apiHeader(),
        })
        .then(response => {
            // FileDownload(response.data, 'file.txt');
            // saveAs(response.data, 'file.xlsx')
            dispatch({
                type: TRANSACTION_DOWNLOAD_SUCCESS,
                payload: response
            })
            response.data.status !== true ? toast.error(response.data.message, { theme: "colored" }) : toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: TRANSACTION_DOWNLOAD_ERROR,
                payload: errors
            })
        })
}

export const GetTransactionDownloadFiles = () => async (dispatch) => {
    dispatch({ type: IS_LOADING });

    try {
        const response = await axios.get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/transaction/get-downloads`, {
            headers: apiHeader(),
        });

        console.log("GetTransactionDownloadFiles, response", response?.data)
        dispatch({
            type: TRANSACTION_GET_DOWNLOAD_FILES_SUCCESS,
            payload: response?.data?.data || [],
        });
    } catch (error) {
        dispatch({
            type: TRANSACTION_GET_DOWNLOAD_FILES_ERROR,
            payload: [],
        });
    }
};

export const downloadTransactionFile = (fileId, fileName) => async () => {
    try {
        const response = await axios.get(
            `${baseUrlPostGres()}/admin/${apiVersion.v1}/transaction/download-file/${fileId}`,
            {
                responseType: "blob",
                headers: apiHeader(),
            }
        );

        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        saveAs(blob, fileName || "transaction.xlsx");
    } catch (error) {
        console.error("Download error:", error);
    }
};
export const deleteAllFiles = () => async (dispatch) => {
    try {
        await axios.delete(
            `${baseUrlPostGres()}/admin/${apiVersion.v1}/transaction/files`,
            { headers: apiHeader() }
        );

        dispatch({
            type: TRANSACTION_GET_DOWNLOAD_FILES_SUCCESS,
            payload: [],
        });

        toast.success("All files deleted successfully!");
    } catch (error) {
        console.error("Delete error:", error);
        toast.error("Failed to delete files!");
    }
};


let debounceTimerTransactionFilter;
export const TransactionFilter = (body) => (dispatch) => {
    return new Promise((resolve) => {
        const timeout = debounceTimerTransactionFilter ? 1000 : 100;
        if (debounceTimerTransactionFilter) clearTimeout(debounceTimerTransactionFilter);
        debounceTimerTransactionFilter = setTimeout(async () => {
            dispatch({ type: IS_LOADING });

            try {
                const response = await axios.post(
                    `${baseUrlPostGres()}/admin/${apiVersion.v1}/transaction/filter`,
                    body,
                    { headers: apiHeader() }
                );

                dispatch({
                    type: TRANSACTION_FILTER_SUCCESS,
                    payload: response
                });

                if (response.data.status === false) {
                    toast.error(response.data.message, { theme: "colored" });
                }
            } catch (errors) {
                HandleError(errors.response?.data);

                dispatch({
                    type: TRANSACTION_FILTER_ERROR,
                    payload: errors
                });

                toast.error(errors?.error?.errorMessage?.id?.message, { theme: "colored" });
            }

            resolve(true)
        }, timeout);
    });
};




export const GetWithDrawalListAction = (page, size) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/wallet/Withdraw/list?page=${page}&size=${size}`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: WITHDRAWAL_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: WITHDRAWAL_LIST_ERROR,
                payload: errors
            })
        })
}

export const GetWalletListAction = (page, size) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/wallet/list?page=${page}&size=${size}`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: WALLET_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: WALLET_LIST_ERROR,
                payload: errors
            })
        })
}

export const WalletFilterAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/wallet/filter`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: WALLET_FILTER_SUCCESS,
                payload: response
            })
            response.data.status == false && toast.error(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: WALLET_FILTER_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}

export const WalletAmountUpdatection = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/wallet/update`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: WALLET_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: WALLET_UPDATE_ERROR,
                payload: errors
            })
        })
}

export const ResetWalletAmountUpdatection = () => async (dispatch) => {
    dispatch({
        type: WALLET_UPDATE_SUCCESS,
        payload: {}
    })
}

export const GetTDSListAction = (page, size, data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/tds/list?page=${page}&size=${size}`,
            data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: TDS_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            console.log("errors-->>", errors)
            HandleError(errors?.response?.data)
            dispatch({
                type: TDS_LIST_ERROR,
                payload: errors
            })
        })
}


export const ResetTDSListAction = () => async (dispatch) => {
    dispatch({
        type: TDS_LIST_SUCCESS,
        payload: {}
    })
}

export const WalletTransAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/trans_withdraw_req`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: WALLET_TRANS_SUCCESS,
                payload: response
            })
            response.data.status == false && toast.error(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: WALLET_TRANS_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}

export const WalletTransTDSAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/trans_tds_req`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: WALLET_TRANS_SUCCESS,
                payload: response
            })
            response.data.status == false && toast.error(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: WALLET_TRANS_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}